module.exports = __webpack_public_path__ + "static/media/gojek-rentals-desktop.3db88624.svg";